module.exports = __webpack_public_path__ + "static/media/seriousConsequences.14b37926.m4a";